import { useLang } from "../../i18n/LangContext";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden border-y border-white/10 py-8 lg:py-10" data-testid="services-marquee">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="flex shrink-0 items-center">
            <span className={`font-display text-5xl font-bold tracking-tight lg:text-7xl ${i % 2 ? "italic text-saffron" : "text-white"}`}>{w}</span>
            <span className="mx-8 inline-block h-3 w-3 rotate-45 bg-saffron lg:mx-12" />
          </span>
        ))}
      </div>
    </div>
  );
};
